import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { 
        requestSaveOneClickSettings,
        requestSaveMobileStakesExchangeGameSettings,
        requestSaveMobileStakesSettings,
        requestSaveStakesSettings
      } from '../../store/user/user.thunks';
import { requestStack } from '../../store/auth/auth.thunks';

export const connectSettings = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      user: state.user,
      elementsParams: state.elementsParams,
      auth: state.auth
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestSaveOneClickSettings,
      requestSaveMobileStakesExchangeGameSettings,
      requestSaveMobileStakesSettings,
      requestSaveStakesSettings,
      requestStack
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
